/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleMerchantCatalogProductData } from './GoogleMerchantCatalogProductData';
import {
    GoogleMerchantCatalogProductDataFromJSON,
    GoogleMerchantCatalogProductDataFromJSONTyped,
    GoogleMerchantCatalogProductDataToJSON,
    GoogleMerchantCatalogProductDataToJSONTyped,
} from './GoogleMerchantCatalogProductData';

/**
 * 
 * @export
 * @interface GoogleMerchantCatalogProductPageData
 */
export interface GoogleMerchantCatalogProductPageData {
    /**
     * 
     * @type {Array<GoogleMerchantCatalogProductData>}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    products?: Array<GoogleMerchantCatalogProductData>;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    totalPages?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    completeness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantCatalogProductPageData
     */
    publishedAt?: string | null;
}

/**
 * Check if a given object implements the GoogleMerchantCatalogProductPageData interface.
 */
export function instanceOfGoogleMerchantCatalogProductPageData(value: object): value is GoogleMerchantCatalogProductPageData {
    return true;
}

export function GoogleMerchantCatalogProductPageDataFromJSON(json: any): GoogleMerchantCatalogProductPageData {
    return GoogleMerchantCatalogProductPageDataFromJSONTyped(json, false);
}

export function GoogleMerchantCatalogProductPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantCatalogProductPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(GoogleMerchantCatalogProductDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'available': json['available'] == null ? undefined : json['available'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
    };
}

export function GoogleMerchantCatalogProductPageDataToJSON(json: any): GoogleMerchantCatalogProductPageData {
    return GoogleMerchantCatalogProductPageDataToJSONTyped(json, false);
}

export function GoogleMerchantCatalogProductPageDataToJSONTyped(value?: GoogleMerchantCatalogProductPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(GoogleMerchantCatalogProductDataToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'totalItems': value['totalItems'],
        'totalPages': value['totalPages'],
        'available': value['available'],
        'completeness': value['completeness'],
        'publishedAt': value['publishedAt'],
    };
}

